module.exports = __webpack_public_path__ + "static/media/hoc6.f20816a2.jpg";